import { ScreenManager } from "../../managers/ScreenManager";
import { Showable } from "../../mixins/Showable";
import { ApplyMixins } from "../../utils/ApplyMixins";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { GetViewportSize } from "../../utils/GetViewportSize";
import { RectSize } from "../../utils/RectSize";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { GamePlayDirection } from "../managers/AppSettings";
import { Player } from "../player/Player";
import { TableScreen } from "../screen/TableScreen";


// linting
export interface DealerChipController extends Showable { }

/**
 * internal chip state
 */
enum ChipState {
    /**
     * snapped to player
     */
    INSIDE_PLAYER,
    /**
     * most likely transitioning from player to player
     */
    OUTSIDE_PLAYER,
}

/**
 * Container and a Controller for chip (animate chip from to, snap chip to player, ..)
 */
export class DealerChipController
    extends Phaser.GameObjects.Container {
    private static appliedMixins: boolean = false;
    public dealerChip: Phaser.GameObjects.Image;
    public table: TableScreen;

    protected trickDealerIndex: number;
    protected transitionalChipPosition: Phaser.Geom.Point;
    protected chipState: ChipState;


    public Init(table: TableScreen): void {
        if (!DealerChipController.appliedMixins) {
            ApplyMixins(DealerChipController, [Showable]);
            DealerChipController.appliedMixins = true;
        }

        this.table = table;

        this.isShowing = false;
        this.transitionalChipPosition = new Phaser.Geom.Point();
    }

    public Build(): void {
        this.dealerChip = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "dealerChip.png" });
        // this.view.scale = 0.5;
        this.add(this.dealerChip);
    }

    public Registeristeners(): void {
        // console.trace("reg");
        this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.OnUpdate, this);
    }

    public UnRegisteristeners(): void {
        // console.log("unreg");
        this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.OnUpdate);
    }

    public SetDealerIndex(trickDealerIndex: number): void {
        this.trickDealerIndex = trickDealerIndex;
    }

    public SnapToPlayer(playerIndex: number = undefined, animate: boolean = false): void {
        // console.log("SnapToPlayer");

        playerIndex = playerIndex ?? this.trickDealerIndex;
        const player: Player = this.table.players.GetPlayerByIndex(playerIndex);
        player.chipContainer.add(this);
        this.setPosition(0);
    }

    /**
     * 
     * @param prevDealerIndex 
     * @param nextDealerIndex 
     * @param manualResize true runs manual resize on table
     */
    public SnapAnimateFromTo(
        prevDealerIndex: number,
        nextDealerIndex: number,
        onComplete: Function = undefined,
        manualResize: boolean = false
    ): void {
        // prevDealerIndex = 2;
        // nextDealerIndex = 1;
        const prevPlayer: Player = this.table.players.GetPlayerByIndex(prevDealerIndex);
        const nextPlayer: Player = this.table.players.GetPlayerByIndex(nextDealerIndex);
        const prevPlayerAvatarBgTM = prevPlayer.avatarBg.getWorldTransformMatrix();
        const nextPlayerAvatarBgTM = nextPlayer.avatarBg.getWorldTransformMatrix();
        this.table.add(this.table.dealerChipController);
        this.table.dealerChipController.setPosition(prevPlayerAvatarBgTM.tx, prevPlayerAvatarBgTM.ty);
        this.table.dealerChipController.setScale(prevPlayerAvatarBgTM.a, prevPlayerAvatarBgTM.d);

        // console.log(prevPlayer.x, prevPlayer.y);
        // console.log(prevPlayerAvatarBgTM.tx, nextPlayerAvatarBgTM.tx, nextPlayerAvatarBgTM.tx - prevPlayerAvatarBgTM.tx);

        // build table view from said data
        // this.UpdateViewFromData();
        // fade in table contents from state
        // this.table.OnShowStart(null, null, false); // registerListeners?

        if (manualResize) {
            this.table.OnResizeManual();
        }

        // animate chip from prev player to next player
        let timeScale: number = OptionsDataManager.GetTiming();
        // timeScale = 1;
        this.table.scene.tweens.chain({
            targets: this.table.dealerChipController,
            tweens: [
                {
                    // x: midPosition.x,
                    // y: midPosition.y,
                    x: prevPlayerAvatarBgTM.tx + (nextPlayerAvatarBgTM.tx - prevPlayerAvatarBgTM.tx) * 0.5,
                    y: prevPlayerAvatarBgTM.ty + (nextPlayerAvatarBgTM.ty - prevPlayerAvatarBgTM.ty) * 0.5,
                    scale: prevPlayerAvatarBgTM.a * 1.5,
                    ease: Phaser.Math.Easing.Cubic.In,
                    duration: 500 * timeScale,
                },
                {
                    x: nextPlayerAvatarBgTM.tx,
                    y: nextPlayerAvatarBgTM.ty,
                    scale: nextPlayerAvatarBgTM.a, // scaleX
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500 * timeScale,
                },
                {
                    scale: 0,
                    ease: Phaser.Math.Easing.Cubic.In,
                    duration: 300 * timeScale,
                    onComplete: () => {
                        this.table.dealerChipController.SnapToPlayer(nextDealerIndex);
                    },
                },
                {
                    scale: 1,
                    ease: (t: number) => Phaser.Math.Easing.Elastic.Out(t, 2.0, 1.0),
                    duration: 700 * timeScale,
                    onComplete: () => {
                        this.table.dealerChipController.scale = 1;
                        // start next table Deal (Task)
                        // this.Start();
                        onComplete?.();
                    }
                }
            ],
        });
    }

    /**
     * Kill chip animation and reset it's props to animation inits
     */
    public Reset(): void {
        this.table.scene.tweens.killTweensOf(this.table.dealerChipController);
        this.table.dealerChipController.scale = 1;
    }

    protected OnUpdate(elapsed: number, delta: number): void {
        // this.dealerChip.angle += 0.05 * delta;
    }
}